// extracted by mini-css-extract-plugin
module.exports = {"card":"cardDetails_card__x5icJ","name":"cardDetails_name__r3K_B","logo":"cardDetails_logo__ECtEk","expiration":"cardDetails_expiration__Fhu_X"};